import { render, staticRenderFns } from "./flightBoard.vue?vue&type=template&id=fbd2be5e&scoped=true&"
import script from "./flightBoard.vue?vue&type=script&lang=js&"
export * from "./flightBoard.vue?vue&type=script&lang=js&"
import style0 from "./flightBoard.vue?vue&type=style&index=0&id=fbd2be5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd2be5e",
  null
  
)

export default component.exports